<template>
  <div class="statusBar">
    <h3>Причина:</h3>
    <ul id="main_status">
      <li v-for="item in statusReasonList">
        <label v-bind:style="item.bg">
          <input type="radio" v-model="reasonStatus" :value="item.id">
          <span>{{item.name}}</span>
        </label></li>
    </ul>
<!--    <div v-if="subStatusList.length > 0">-->
<!--      <h3>Уточнение:</h3>-->
<!--      <ul>-->
<!--        <li v-for="item in subStatusList">-->
<!--          <label v-bind:style="item.bg">-->
<!--            <input type="radio" v-model="SubCallStatus" :value="item.name">-->
<!--            <span>{{item.name}}</span>-->
<!--          </label>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->

<!--    <div>-->
<!--      <h3>Комментарий оператора:</h3>-->
<!--      <textarea v-model="OperatorMsg"></textarea>-->
<!--    </div>-->

    <div v-if="reasonStatus === 6">
      <div class="input_box fl">
        <div>
          <label  class="left">Дата перезвона</label>
          <input v-model="newCallDate" type="date"/>
        </div>
      </div>

      <div class="input_box fl">
        <div>
          <label  class="left">Время перезвона</label>
          <input v-model="newCallTime" type="time"/>
        </div>
      </div>

    </div>

  </div>

</template>

<script>
  //todo дообавить поля перезвона, с датой и временем
  import StatusListLib from '@/gavnoCode/statusList';
  import {mapGetters, mapState} from 'vuex'

  export default {
    name: "statusBarIn",
    props: {
      statusReasonList: {
        type: Array,
        default() {
          return []
        }
      }
    },
    data: function () {
      return {
        subStatusList: [],
        // OperatorMsg: ''
      }
    },
    methods: {
      saveStatus:function(){
        alert('запрос на сохранение статуса')
      },

      chekIssetSubStatus: function (item) {
        return !!item.subStatus;
      },
      returnStatusObject: function(value){
        //поиск объекта по значению
        let thisStatus = this.statusReasonList.filter(item => {
          if (item.name == value) {
            return true;
          }
        });
        if(thisStatus.length === 1) {
          return thisStatus[0];
        } else {
          return [];
        }
      },
      selectedStatusObject: function(element, index){
        if (element.name == this.CallStatus) {
          return element;
        }
      }
    },
    watch: {
      // reasonStatus: function (value) {
      //   //смотрим на выбранный статус, если есть доп статусы показываем их, если заявка, то показываем форму
      //   let thisStatus = this.returnStatusObject(value);
      //   //пробел присваивается, потому, что блокируется запись изменения в хранилище, если пришла пусто....
      //   // хз зачем так сделал.
      //   this.SubCallStatus = ' ';
      //   if (this.chekIssetSubStatus(thisStatus)) {
      //     this.subStatusList = thisStatus.subStatus;
      //   } else {
      //     this.subStatusList = [];
      //   }
      // },
    },
    computed:{


      newCallTime:{
        get(){
          return this.valueVuex['onlineSimple']['newCallTime']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'newCallTime',
            form:'onlineSimple',
            value: value
          });
        }
      },
      newCallDate:{
        get(){
          return this.valueVuex['onlineSimple']['newCallDate']
        },
        set(value){
          this.$store.dispatch('saveSendData',{
            target:'newCallDate',
            form:'onlineSimple',
            value: value
          });
        }
      },


      reasonStatus:{
        get(){
          return this.valueVuex['onlineSimple']['reasonStatus']
        },
        set(value){
          if (this.valueVuex['onlineSimple']['callStatus'] === 6 && value === 6) {
            this.$store.dispatch('saveSendData',{
              target:'reasonStatus',
              form:'onlineSimple',
              value: value
            });
            this.$store.dispatch('saveSendData',{
              target:'callStatus',
              form:'onlineSimple',
              value: 0
            });
          } else {
            this.$store.dispatch('saveSendData',{
              target:'reasonStatus',
              form:'onlineSimple',
              value: value
            });
          }
        }
      },
      // SubCallStatus: {
      //   get(){
      //     return this.valueVuex['status']['SubCallStatus']
      //   },
      //   set(value){
      //
      //     this.$store.dispatch('saveSendData',{
      //       target:'SubCallStatus',
      //       form:'status',
      //       value: value
      //     });
      //   }
      // },

      ...mapState({
        valueVuex: state => state.requestField.sendData,
        statusVuex: state => state.requestField.workData
      })
    }
  }
</script>

<style scoped>
  .statusBar {
  }

  .statusBar ul {
    list-style: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin: 0;
    padding: 0;
  }

  .statusBar ul li {
    width: 16%;
    min-height: 45px;
    margin: 3px 0.8% 3px 0;
  }
  .statusBar ul li:nth-child(6n) {margin-right: 0;}

  .statusBar ul li label {
    display: flex;
    align-items: center;
    height: 100%;
    cursor: pointer;
    justify-content: flex-start;
    text-align: left;
    background:rgba(45, 130, 103, 0.32)
  }

  .statusBar ul li label:hover {
    background: rgba(15, 87, 64, 0.11);
    box-shadow: 1px 2px 6px 4px rgba(11, 58, 15, 0.66);
  }

  .statusBar ul li label input {
    width: 20px;
  }

  .statusBar ul li label span {
    font-size: 15px;
    line-height: 0.8;
    width: calc(100% - 30px);
  }

  textarea {
    width: calc(100% - 2px - 10px);
    height: 80px;
    border: 1px solid rgb(15, 87, 64);
  }
</style>
